import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'

const CHAMFER_URL = `${POSITION_PROPERTY_URL}/chamfers`

const errors = createHandbookResponseErrors('фаску', 'фасок')

export const ChamferApi = createNewHandbookApi(CHAMFER_URL, errors)
